import { Injectable, Injector } from '@angular/core';
import { SdkBase } from '../utilities/sdk-base/sdk.base';
import { RedactionAnnotationCreateImageRequest } from '../components/review/redaction-annotation/redaction-annotation-create-image-request.model';
import { RedactionAnnotationCreatePdfRequest } from '../components/review/redaction-annotation/redaction-annotation-create-pdf-request.model';
import { Observable } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class RedactionAnnotationRequestSdk extends SdkBase {

	constructor(
		injector: Injector) {
		super(injector);
	}

	public createImageRequest(body: RedactionAnnotationCreateImageRequest): Observable<boolean> {
		return this.makeHttpRequest<boolean>('post', `api2/redactionannotationrequests/createimages`, body);
	}

	public applyEditsRequest(body: RedactionAnnotationCreatePdfRequest): Observable<boolean> {
		return this.makeHttpRequest<boolean>('post', `api2/redactionannotationrequests/applyedits`, body);
	}

}

